import React from 'react';
import { MentalDetail, MentalLinkIdentifier } from '../../types';
import PageTitle from '../../components/PageTitle';
import LessonSection from './LessonSection';

type MentalLessonIndexProps = {
    mental: MentalDetail,
    mentalLinkIdentifier: MentalLinkIdentifier,
}

const MentalLessonIndex = ({ mentalLinkIdentifier, mental }: MentalLessonIndexProps) => (
    <>
        <PageTitle documentTitleParts={[mental.title, 'Übungen']}>
            <span className="mobile-parent-title">{mental.title.length > 20 ? `${mental.title.substring(0, 20)}...` : mental.title}</span>
            <span className="parent-title">{mental.title}</span>
            <strong>Übungen</strong>
        </PageTitle>
        {mental.lessonSections.map(lessonSection => (
            <LessonSection
                key={lessonSection.id}
                mental={mentalLinkIdentifier}
                infoDialogLayout={mental.infoWindowLayout}
                lessonSection={lessonSection}
            />
        ))}
    </>
);

export default MentalLessonIndex;
